import * as moment from 'moment';

import { ISODate } from './types';

const getDay = (date?: ISODate): number => moment(date).date();

export default getDay;
